/**
 * Object.keys, only type safe!
 */
export function objectKeys<T extends {}>(subject: T): (keyof T)[] {
  return Object.keys(subject) as (keyof T)[];
}
